import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { useEffect } from "react";
import { Toaster } from "sonner";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import ExitIntentPopup from "@/components/ExitIntentPopup";
import CookieConsentInit from "@/components/CookieConsentInit";
import HomePage from "@/pages/HomePage";
import PackagesPage from "@/pages/PackagesPage";
import ServicesPage from "@/pages/ServicesPage";
import AboutPage from "@/pages/AboutPage";
import FAQPage from "@/pages/FAQPage";
import B2BPage from "@/pages/B2BPage";
import NotFoundPage from "@/pages/NotFoundPage";
import ContactPage from "@/pages/ContactPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import CookiesPage from "@/pages/CookiesPage";

function ScrollToTop() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo(0, 0); }, [pathname]);
  return null;
}

function AppLayout() {
  return (
    <>
      <ScrollToTop />
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<HomePage />} />
          <Route path="/pachete" element={<PackagesPage />} />
          <Route path="/servicii" element={<ServicesPage />} />
          <Route path="/despre" element={<AboutPage />} />
          <Route path="/faq" element={<FAQPage />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/b2b" element={<B2BPage />} />
          <Route path="*" element={<NotFoundPage />} />
          <Route path="/politica-confidentialitate" element={<PrivacyPage />} />
          <Route path="/termeni-conditii" element={<TermsPage />} />
          <Route path="/politica-cookies" element={<CookiesPage />} />
        </Routes>
      </main>
      <Footer />
      <ExitIntentPopup />
      <CookieConsentInit />
    </>
  );
}

function App() {
  return (
    <div className="min-h-screen bg-[#FAFAFA]">
      <Toaster position="top-right" richColors />
      <BrowserRouter basename={import.meta.env.BASE_URL}>
        <AppLayout />
      </BrowserRouter>
    </div>
  );
}

export default App;
